import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { PrimaryTypography, TypographyDefault } from "../Theme";
import { ReactComponent as Close } from "../Icons/BorderAlertClose.svg";

const AlertModal = ({
  modalDatas,
  confirmFunction,
  closeFunction,
  isDraft,
  loading,
}) => {
  let {
    label,
    descriptionOne,
    descriptionTwo,
    buttonOne,
    buttonTwo,
    isDeleteCompany,
  } = modalDatas;
  return (
    <>
      <Modal open={true}>
        <Box
          sx={{
            position: "absolute",
            border: "none",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              width: "40%",
              borderRadius: "8px",
            }}
          >
            <Box
              sx={{
                p: 2,
                borderBottom: "2px solid #F3F4F6",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <PrimaryTypography>{label}</PrimaryTypography>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => closeFunction()}
              />
            </Box>
            <Box sx={{ px: 2, py: 3, borderBottom: "2px solid #F3F4F6" }}>
              {isDeleteCompany ? (
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 600, color: "#1F2A37" }}
                >
                  {isDeleteCompany}
                  <span
                    style={{
                      color: "#111927",
                      fontSize: "14px",
                      fontWeight: 400,
                      marginLeft: "10px",
                    }}
                  >
                    {descriptionOne}
                  </span>
                </Typography>
              ) : (
                <TypographyDefault>{descriptionOne}</TypographyDefault>
              )}

              {descriptionTwo != "" && (
                <TypographyDefault sx={{ mt: 3 }}>
                  {descriptionTwo}
                </TypographyDefault>
              )}
            </Box>
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: isDraft ? "end" : "space-between",
              }}
            >
              <Button
                onClick={() => closeFunction()}
                sx={{
                  background: buttonOne.backgroundColor,
                  color: buttonOne.color,
                  marginRight: isDraft ? "20px" : "initial",
                }}
                variant={buttonOne.variant}
              >
                {buttonOne.text}
              </Button>
              <Button
                onClick={() => confirmFunction()}
                sx={{
                  background: buttonTwo.backgroundColor,
                  color: buttonTwo.color,
                  "&:hover": { background: buttonTwo.backgroundColor },
                }}
                variant={buttonTwo.variant}
              >
                {loading ? (
                  <CircularProgress size={25} color="inherit" />
                ) : (
                  buttonTwo.text
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AlertModal;
